import { defineAsyncComponent } from 'vue';

export default {
    // Add global components here
    components: {
        // Container octolo with auto adjust height/width (scroll)
        OctoloContent: defineAsyncComponent(() => import('@/components/Content.vue')),
        // OctoloToolbar
        ToolBar: defineAsyncComponent(() => import('@/components/ToolBar.vue')),
        // Graphic container
        GraphicContainer: defineAsyncComponent(() => import('@/components/GraphicContainer.vue')),
        // Search bar
        SearchBar: defineAsyncComponent(() => import('@/components/SearchBar.vue')),
        // Input select
        InputSelect: defineAsyncComponent(() => import('@/components/InputSelect.vue')),
        // Pagination
        Pagination: defineAsyncComponent(() => import('@/components/Pagination.vue')),
        // Button
        ChoiceButton: defineAsyncComponent(() => import('@/components/ChoiceButton.vue')),
        OctoloChoice: defineAsyncComponent(() => import('@/components/Choice.vue')),
        // Buttons
        SimpleButton: defineAsyncComponent(() => import('@/components/Button.vue')),
        // Tabs
        SimpleTabs: defineAsyncComponent(() => import('@/components/Tabs.vue')),
        // Signature
        OctoloSignature: defineAsyncComponent(() => import('@/components/Signature.vue')),
        OctoloGrid: defineAsyncComponent(() => import("@/components/Grid.vue")),
        OctoloStatCard: defineAsyncComponent(() => import('@/components/StatCard.vue')),
        OctoloIa: defineAsyncComponent(() => import('@/components/OctoloIA.vue')),
    },
}
